import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import "react-circular-progressbar/dist/styles.css";
import "./css/Home.css";
import {AuthContext, ToastContext} from "../App";
import {FaCheck, FaPlayCircle} from "react-icons/fa";
import Select from "react-select";
import { useParams } from "react-router-dom";

function Home() {
    const [programsByType, setProgramsByType] = useState({});
    const [selectedType, setSelectedType] = useState("تمارين");
    const [selectedProgramIndex, setSelectedProgramIndex] = useState(0);
    const [selectedDay, setSelectedDay] = useState(0);
    const [allLogs, setAllLogs] = useState({});
    const [savedLogs, setSavedLogs] = useState({});
    const showToast = useContext(ToastContext);
    const [loaded, setLoaded] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState(null);


    const { userId: authUserId } = useContext(AuthContext);
    const { memberId } = useParams();
    const userId = memberId || authUserId;
    const isAdminView = !!memberId;


    useEffect(() => {
        if (!userId || loaded) return;
        setLoaded(true);
        fetchPrograms();
    }, [userId]);

    const fetchPrograms = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/member-programs/${userId}`
            );
            console.log("📥 بيانات السيرفر:", res.data);
            setProgramsByType(res.data);

            const types = Object.keys(res.data);
            if (types.length > 0) {
                const firstType = types.includes("تمارين") ? "تمارين" : types[0];
                const firstProgram = res.data[firstType][0];
                setSelectedType(firstType);
                setSelectedProgramIndex(0);
                setSelectedDay(firstProgram.days?.[0]?.day_number || "");

                if (firstProgram.program.type === "تمارين") {
                    loadLogs(firstProgram);
                }
            }
        } catch (err) {
            console.error(err);
            showToast("خطأ في جلب البرامج", "danger");
        }
    };

    const loadLogs = (program) => {
        if (program.program.type !== "تمارين") return;

        const logs = {};
        const saved = {};

        program.days?.forEach((day) => {
            day.exercises?.forEach((ex) => {
                ex.logs?.forEach((log) => {
                    const key = `${day.day_number}_${ex.id}_${log.set_number}`;
                    logs[key] = {
                        weight: log.weight,
                        reps: log.reps,
                        created_at: log.created_at,
                    };
                    saved[key] = true;
                });
            });
        });

        setAllLogs((prev) => ({
            ...prev,
            [program.member_program_id]: logs,
        }));
        setSavedLogs((prev) => ({
            ...prev,
            [program.member_program_id]: saved,
        }));
    };

    const handleTypeChange = (type) => {
        setSelectedType(type);
        setSelectedProgramIndex(0);
        const program = programsByType[type][0];
        setSelectedDay(program.days?.[0]?.day_number || "");
        if (program.program.type === "تمارين") loadLogs(program);
    };

    const handleProgramChange = (index) => {
        setSelectedProgramIndex(index);
        const program = programsByType[selectedType][index];
        setSelectedDay(program.days?.[0]?.day_number || "");
        if (program.program.type === "تمارين") loadLogs(program);
    };

    const handleDayChange = (dayNumber) => {
        setSelectedDay(dayNumber);
    };

    const handleChange = (dayNumber, exId, setNumber, field, value) => {
        const program = programsByType[selectedType][selectedProgramIndex];
        const logs = allLogs[program.member_program_id] || {};
        const key = `${dayNumber}_${exId}_${setNumber}`;
        const updated = { ...logs, [key]: { ...logs[key], [field]: value } };
        setAllLogs((prev) => ({ ...prev, [program.member_program_id]: updated }));
    };

    const saveLog = async (dayNumber, exId, setNumber) => {
        const program = programsByType[selectedType][selectedProgramIndex];
        const logs = allLogs[program.member_program_id];
        const key = `${dayNumber}_${exId}_${setNumber}`;
        const entry = logs[key];

        if (!entry || !entry.weight || !entry.reps) {
            showToast("يرجى ملء الوزن والعدد", "danger");
            return;
        }

        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/exercise-logs`, {
                member_program_id: program.member_program_id,
                day_number: dayNumber,
                exercise_id: exId,
                set_number: setNumber,
                weight: entry.weight,
                reps: entry.reps,
            });

            const now = new Date().toISOString();

            setAllLogs((prev) => ({
                ...prev,
                [program.member_program_id]: {
                    ...(prev[program.member_program_id] || {}),
                    [key]: {
                        ...entry,
                        created_at: now,
                    },
                },
            }));

            setSavedLogs((prev) => ({
                ...prev,
                [program.member_program_id]: {
                    ...(prev[program.member_program_id] || {}),
                    [key]: true,
                },
            }));

            showToast("تم حفظ الأداء", "success");
        } catch (err) {
            console.error(err);
            showToast("حدث خطأ أثناء الحفظ", "danger");
        }
    };

    if (!Object.keys(programsByType).length) {
        return (
            <div dir="rtl">
                <div className="container" style={{ marginTop: "90px" }}>
                    <h3 className="text-center mt-4">لا يوجد برنامج مخصص لك بعد</h3>
                </div>
            </div>
        );
    }

    const programs = programsByType[selectedType];
    const programData = programs[selectedProgramIndex];
    const { program, days } = programData;
    const logs = allLogs[programData.member_program_id] || {};

    const dayProgress = () => {
        if (program.type !== "تمارين") return 0;
        const day = days.find((d) => d.day_number === selectedDay);
        if (!day) return 0;

        let totalSets = 0;
        let completedSets = 0;

        day.exercises.forEach((ex) => {
            for (let i = 1; i <= ex.target_reps; i++) {
                totalSets++;
                const key = `${day.day_number}_${ex.id}_${i}`;
                if (logs[key]?.reps && Number(logs[key].reps) > 0) completedSets++;
            }
        });

        return totalSets === 0
            ? 0
            : Math.round((completedSets / totalSets) * 100);
    };

    const startDate = new Date(programData.start_date);
    const endDate = new Date(startDate);
    endDate.setDate(
        startDate.getDate() + programData.renew_interval_days - 1
    );
    const programOptions = programs.map((p, i) => ({
        value: i,
        label: `${p.program.name} (${new Date(p.start_date).toLocaleDateString("ar-EG")})`,
    }));

    function convertArabicToEnglishNumbers(value) {
        const arabicNumbers = ['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
        return value.replace(/[٠-٩]/g, (d) => arabicNumbers.indexOf(d));
    }

    return (
        <div className={''} dir="rtl">
            <div className="container mt-5 homepage">
                <h2 className="text-center mb-4">{program.name} ({program.type})</h2>
                <p className="text-center text-muted mb-4">
                    تاريخ نهاية البرنامج: {endDate.toLocaleDateString("ar-EG")}
                </p>

                {/* اختر النوع */}
                <div className="mb-4">
                    <label className="form-label fw-bold">اختر النوع:</label>
                    <div className="d-flex rounded-pill overflow-hidden border border-secondary" style={{ cursor: "pointer" }}>
                        {Object.keys(programsByType).map((type, index) => (
                            <div
                                key={type}
                                onClick={() => handleTypeChange(type)}
                                className={`flex-fill text-center py-2 transition ${selectedType === type ? 'bg-success text-white' : 'bg-white'} ${index !== 0 ? 'border-start' : ''}`}
                            >
                                {type}
                            </div>
                        ))}
                    </div>
                </div>

                {/* اختر البرنامج واليوم */}
                <div className="row g-3 mb-4">
                    <div className="col-12 col-md-6">
                        <label className="form-label fw-bold">اختر البرنامج:</label>
                        <Select
                            options={programOptions}
                            value={programOptions[selectedProgramIndex]}
                            onChange={(selected) => handleProgramChange(selected.value)}
                            isSearchable
                            placeholder="ابحث عن البرنامج..."
                            styles={{ overflowY: "auto" }}
                        />
                    </div>

                    <div className="col-12 col-md-6">
                        <label className="form-label fw-bold">اختر اليوم:</label>
                        {days.length > 0 ? (
                            <select
                                className="form-select"
                                value={selectedDay}
                                onChange={(e) => handleDayChange(e.target.value)}
                            >
                                {days.map((day) => (
                                    <option key={day.day_number} value={day.day_number}>
                                         {day.day_number}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            <p className="text-center text-muted">لا توجد أيام لهذا البرنامج</p>
                        )}
                    </div>
                </div>

                {program.type === "تمارين" && days.length > 0 && (
                    <div className="my-4">
                        <div className="d-flex justify-content-between mb-1">
                            <span className="fw-bold">مستوى التقدم</span>
                            <span className="fw-bold">{dayProgress()}%</span>
                        </div>
                        <div className="progress" style={{ height: "20px", borderRadius: "10px" }}>
                            <div
                                className={`progress-bar bg-success`}
                                role="progressbar"
                                style={{ width: `${dayProgress()}%` }}
                                aria-valuenow={dayProgress()}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            ></div>
                        </div>
                    </div>
                )}

                {/* محتوى الأيام */}
                {days
                    .filter((d) => d.day_number === selectedDay)
                    .map((day) => (
                        <div key={day.day_number} className="mb-3 p-3 border rounded bg-light">
                            <h4> {day.day_number}</h4>

                            {/* --- تمارين --- */}
                            {program.type === "تمارين" && (
                                <div className="row g-3">
                                    {day.exercises.map((ex) => (
                                        <div key={ex.id} className="col-12 col-md-6">
                                            <div className="p-3 border rounded bg-white exercise-card">
                                                <h6 className="d-flex align-items-center justify-content-between">
  <span>
    {ex.name} ({ex.target_reps} عدات)
  </span>

                                                    {ex.video_url && (
                                                        <FaPlayCircle
                                                            style={{
                                                                cursor: "pointer",
                                                                color: "#0d6efd",
                                                                marginLeft: "8px",
                                                                flexShrink: 0,
                                                            }}
                                                            size={24}
                                                            title="عرض الفيديو"
                                                            onClick={() => setSelectedVideo(`${process.env.REACT_APP_BACKEND_URL}${ex.video_url}`)}
                                                        />
                                                    )}
                                                </h6>

                                                {[...Array(ex.target_reps)].map((_, i) => {
                                                    const key = `${day.day_number}_${ex.id}_${i + 1}`;
                                                    return (
                                                        <div
                                                            key={i}
                                                            className="exercise-row d-flex flex-column gap-1 mb-1"
                                                        >
                                                            <span>جولة {i + 1}:</span>

                                                            <div className="exercise-row-main d-flex gap-2 align-items-center flex-nowrap">
                                                                <input
                                                                    type="text"
                                                                    placeholder="الوزن"
                                                                    className="form-control"
                                                                    style={{ width: "100px" }}
                                                                    disabled={isAdminView}
                                                                    value={logs[key]?.weight || ""}
                                                                    onChange={(e) => {
                                                                        const englishValue = convertArabicToEnglishNumbers(e.target.value);
                                                                        handleChange(day.day_number, ex.id, i + 1, "weight", englishValue);
                                                                    }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    placeholder="العدد"
                                                                    className="form-control"
                                                                    style={{ width: "100px" }}
                                                                    disabled={isAdminView}
                                                                    value={logs[key]?.reps || ""}
                                                                    onChange={(e) => {
                                                                        const englishValue = convertArabicToEnglishNumbers(e.target.value);
                                                                        handleChange(day.day_number, ex.id, i + 1, "reps", englishValue);
                                                                    }}
                                                                />
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <button
                                                                        onClick={() => saveLog(day.day_number, ex.id, i + 1)}
                                                                        className="btn btn-sm d-flex align-items-center justify-content-center"
                                                                        style={{
                                                                            width: "35px",
                                                                            height: "35px",
                                                                            backgroundColor:
                                                                                savedLogs[programData.member_program_id]?.[`${day.day_number}_${ex.id}_${i + 1}`]
                                                                                    ? "#28a745"
                                                                                    : "#6c757d",
                                                                            color: "white",
                                                                            border: "none",
                                                                            borderRadius: "5px",
                                                                            transition: "background-color 0.3s ease",
                                                                        }}
                                                                        title={
                                                                            savedLogs[programData.member_program_id]?.[`${day.day_number}_${ex.id}_${i + 1}`]
                                                                                ? "تم الحفظ بنجاح"
                                                                                : "حفظ"
                                                                        }
                                                                        disabled={isAdminView}
                                                                    >
                                                                        <FaCheck size={15} />
                                                                    </button>
                                                                    <strong>
                                                                        {logs[key]?.created_at
                                                                            ? new Date(logs[key].created_at).toLocaleString("ar-EG", {
                                                                                weekday: "long",
                                                                                year: "numeric",
                                                                                month: "2-digit",
                                                                                day: "2-digit",
                                                                                hour: "numeric",
                                                                                minute: "2-digit",
                                                                                hour12: true,
                                                                            })
                                                                            : ""}
                                                                    </strong>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* --- غذاء --- */}
                            {program.type === "غذاء" &&
                                day.foods.map((food) => (
                                    <div key={food.id} className="mb-2">
                                        <h6>وجبة:</h6>
                                        <p>{food.notes}</p>
                                    </div>
                                ))}
                        </div>
                    ))}
            </div>
            {selectedVideo && (
                <div
                    className="modal d-block"
                    tabIndex="-1"
                    style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content bg-dark text-white">
                            <div className="modal-header">
                                <h5 className="modal-title">عرض الفيديو</h5>
                                <button
                                    className="btn-close btn-close-white"
                                    onClick={() => setSelectedVideo(null)}
                                ></button>
                            </div>
                            <div className="modal-body text-center">
                                <video
                                    src={selectedVideo}
                                    controls
                                    style={{ width: "100%", borderRadius: "10px" }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default Home;
